import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Book } from '../../../../../../models/book';
import { RouteService } from '../../../../../../services/route.service';
import { BookFeatureActivationService } from '../../../../../../services/book-feature-activation.service';
import { BookService } from '../../../../../../services/book.service';
import { ApplicationStateService } from '../../../../../../services/application-state.service';

@Component({
    selector: 'app-last-used-books',
    templateUrl: './last-used-books.component.html',
    styleUrls: ['./last-used-books.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LastUsedBooksComponent implements OnInit {

    usedBooks: Array<Book> = [];

    constructor(public routeService: RouteService,
                public featureActivationService: BookFeatureActivationService,
                private bookService: BookService,
                private changeDetectorRef: ChangeDetectorRef,
                public applicationStateService: ApplicationStateService) {
    }

    /**
     * Called after component creation.
     */
    ngOnInit(): void {
        if (this.applicationStateService.userData.loggedIn) {
            this.bookService.getUsedBooks().then(result => {
                this.usedBooks = result;
                this.changeDetectorRef.detectChanges();
            });
        }
    }
}
